import React from 'react'
import S1about_img from "../../img/S1about_img.jpg"

const S1_about = () => {
  return (
<section className='S1_about'>
    <div className='container'>
        <div className='row'>
            <div className='col-lg-6 card1'>
                <span className='line'></span>
                <h3>Who We Are</h3>    
                <p>Lorem ipsum dolor sit amet, consectetur adipiscing elit. Ut elit tellus, luctus nec ullamcorper mattis, pulvinar dapibus leo. Nam nec tellus a odio tincidunt auctor a ornare odio. Sed non mauris vitae erat consequat auctor eu in elit.</p>

            </div>

            <div className='col-lg-6'>

            <img src={S1about_img} alt='S1about img'/>    


            </div>


        </div>
    </div>          
</section>
  )
}

export default S1_about